import { getSidebarState } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
// @ts-ignore not typed
import { closePatagoniaSidebar } from 'ContentEditorUI/redux/actions/panelActions';
import { addFocusModeStyles, setDisplayValue, createSubTreeNode, FOCUS_MODE_SUBTREE_ID, FOCUS_MODULES_PARENT_ID } from './focusModeUtils';
// @ts-ignore not typed
import { layoutSectionNodePositionsCleared } from '../redux/actions/layoutSectionDndActions';
function animateElement(element, duration) {
  const activeAnimations = document.body.getAnimations({
    subtree: true
  });

  // if there are any active animations happening, we want to cancel those
  // before proceeding to the toggle on/off behavior. This prevents a situation
  // where a user is toggling focus mode on and off very quickly increasing
  // the risk that the DOM elements we are querying aren't available which
  // results in a white screen for the users
  if (activeAnimations.length > 0) {
    activeAnimations.forEach(animation => animation.cancel());
  }

  // Issue: https://git.hubteam.com/HubSpot/ContentEditorUI/issues/17402
  return element.animate({
    opacity: [0, 1]
  }, {
    duration,
    easing: 'ease-in',
    iterations: 1
  });
}

// Focus mode does not currently support external developer use case
// Issue: https://git.hubteam.com/HubSpot/ContentEditorUI/issues/17400
export function focusMode(store) {
  let focusModeSubTree = createSubTreeNode();

  // This forces an update to the module node positions, which corrects a
  // small visual bug where the overlay will show briefly in its former
  // position until a DOM event occurs (hover, scroll, etc)
  function updateNodePositions() {
    store.dispatch(layoutSectionNodePositionsCleared());
  }
  return function toggle({
    value: isFocusModeOn
  }) {
    const state = store.getState();
    const isPatagoniaSidebarClosed = getSidebarState(state).patagoniaSidebarCollapsed;

    // This ID is added by the template creator and the HTML element it is
    // attached to wraps whatever modules the consumer wants to be included
    // within the focused view
    const focusModulesParent = document.body.querySelector(`#${FOCUS_MODULES_PARENT_ID}`);
    const focusModulesMaxWidth = focusModulesParent.offsetWidth;
    const nonFocusModeChildren = document.body.children;
    if (isFocusModeOn) {
      if (!isPatagoniaSidebarClosed) {
        store.dispatch(closePatagoniaSidebar());
      }
      addFocusModeStyles(focusModeSubTree, focusModulesMaxWidth);
      // This will move the children of the hs_focus_mode
      // node into the new focus mode subtree
      // TODO enable the capability to collect multiple nodes instead of
      // relying on the markup to wrap all focus modules in a singular wrapper
      // Issue:https://git.hubteam.com/HubSpot/ContentEditorUI/issues/17399
      focusModeSubTree.appendChild(focusModulesParent.children[0]);
      document.body.prepend(focusModeSubTree);
      animateElement(focusModeSubTree, 350);
      setDisplayValue(nonFocusModeChildren, 'none');
      updateNodePositions();
    } else {
      if (!focusModeSubTree) {
        focusModeSubTree = document.querySelector(`#${FOCUS_MODE_SUBTREE_ID}`);
      }
      focusModulesParent.prepend(focusModeSubTree.children[0]);
      document.body.removeChild(focusModeSubTree);
      animateElement(document.body.children[0], 500);
      setDisplayValue(nonFocusModeChildren, 'block');
      updateNodePositions();
    }
  };
}